module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_pc_writing-3754ddf609b6f278faa19ec449e81aad.png";